<template>
  <div class="container">
    <div class="module_title">
      <span>审核管理 》课程数据</span>

    </div>
    <div class="content">
      <div class="queryBox">
        <el-form ref="ruleForm" style="display: flex;flex-wrap: wrap;">

          <el-form-item label="创建时间：" prop="date">
            <el-date-picker unlink-panels v-model="formatObj.date1" type="datetimerange" range-separator="-"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核状态：" style="width: 180px;">
            <el-select v-model="postForm.audit_state" placeholder="请选择" clearable>
              <el-option v-for="item in options2" :key="item.dictionary_key" :label="item.dictionary_value"
                         :value="item.dictionary_key">
              </el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="发布单位：" prop="" style="width: 300px;">
            <el-input v-model="postForm.enterprise_name" placeholder="请输入发布单位..."></el-input>
          </el-form-item>
          <el-form-item label="课程名称：" style="width: 300px;">
            <el-input v-model="postForm.name" placeholder="请输入课程名称..."></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="search"
                       class="margin_left_20">查询
            </el-button>
          </el-form-item>


        </el-form>
      </div>
      <div class="data_list">

        <el-table :data="tableData" row-key="code" border lazy :stripe="true" :highlight-current-row="true"
                  :header-cell-style="{ background: '#eee', color: '#606266' }" v-loading="loading"
                  element-loading-background="#fff" element-loading-text="数据正在加载中"
                  element-loading-spinner="el-icon-loading" ref="refTable" :height="'100%'"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <!-- <el-table-column prop="enterprise_name" label="图片编号" min-width="155"
:show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="name" label="课程名称" :show-overflow-tooltip="true" width="120">

          </el-table-column>
          <el-table-column prop="intro" label="简介" :show-overflow-tooltip="true" min-width="150">

          </el-table-column>
          <el-table-column prop="enterprise_name" label="发布单位" :show-overflow-tooltip="true" width="150">

          </el-table-column>
          <el-table-column prop="ctime_str" label="创建时间" width="200" :show-overflow-tooltip="true">

          </el-table-column>
          <el-table-column prop="audit_time_str" label="审核时间" width="200" :show-overflow-tooltip="true">

          </el-table-column>
          <el-table-column prop="audit_state" label="审核结果" width="120" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <div v-for="item in options2" :key="item.dictionary_key">
                                <span v-if="item.dictionary_key == row.audit_state">
                                    {{ item.dictionary_value }}
                                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="audit_fail_reason" label="原因" :show-overflow-tooltip="true" width="150">

          </el-table-column>

          <el-table-column prop="file_name" label="文件名称" :show-overflow-tooltip="true" width="200">

          </el-table-column>

          <el-table-column width="180" fixed="right" label="操作">
            <template slot-scope="{row}">
              <el-button @click="oper('4', row)" type="text" size="small">查看</el-button>
              <el-button @click="oper('2', row)" type="text" size="small" class="btn_text_red">删除</el-button>
              <el-button @click="oper('3', row)" type="text" size="small" class="">审核</el-button>
              <el-button @click="previewVideo(row)" type="text" size="small" class="">视频</el-button>

            </template>
          </el-table-column>
        </el-table>


      </div>
      <el-pagination class="pagination" background @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30]"
                     :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </div>
    <previewVideo ref="previewVideo"></previewVideo>
    <dialogForm1 :id="1" ref="dialogForm1" @ok="ok('1')"></dialogForm1>
    <dialogForm2 :id="1" ref="dialogForm2" @ok="ok('2')"></dialogForm2>
    <dialogFormPreview :id="1" ref="dialogFormPreview"></dialogFormPreview>
  </div>
</template>

<script>
import dialogForm1 from './components/dialogForm1.vue'//课程
import dialogForm2 from './components/dialogForm2.vue'//大纲
import dialogFormPreview from './components/dialogFormPreview.vue'
import previewVideo from "@/components/trainingCourse/components/previewVideo";
//预览
export default {
  components: {
    dialogForm1,
    dialogForm2,
    dialogFormPreview,
    previewVideo,
  },
  data() {
    return {
      options1: [],
      options2: [],
      options3: [
        // {
        //     value: '0',
        //     label: '知名企业'
        // },
        // {
        //     value: '1',
        //     label: '上市企业'
        // },
        // {
        //     value: '2',
        //     label: '央企国企'
        // },
        // {
        //     value: '3',
        //     label: '中小民企'
        // },

      ],
      // 搜索区域
      formatObj: {
        date1: [],
        position_type_id: []
      },
      // 分页
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false,
      // 课程视频选择
      checkList: [],
      // 表格数据
      enterpriseOptions: JSON.parse(localStorage.getItem('entinfolist')),
      "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      enterprise_name: '',
      tableData: [],
      postForm: {
        page: 1,
        limit: 10,
        "name": "",
        "outline_id": "",
        "contents_id": "",
        // "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
        "enterprise_id": '',//企业唯一标识
        enterprise_name: '',
        "audit_state": "",
        "ctime_start": "",
        "ctime_end": "",

        // "contents_id": "",//课程大纲目录 ID

        // "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
      },
    }
  },
  created() {
    // this.getPostionTypeOptions()
    this.getDictsData('TM-TC-SHZT', 'options2')
    // this.getDictsData('CM-BQ', 'options3')
    this.getList()
    let obj = this.recursion(this.enterpriseOptions)
    this.enterprise_name = obj.enterprise_name
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    preview() {
      this.$refs.dialogFormPreview.dialogVisible = true
      this.$refs.dialogFormPreview.init()
    },
    // 视频预览
    previewVideo(item) {
      this.$refs.previewVideo.dialogVisible = true;
      this.$refs.previewVideo.init(item);

    },

    // 递归
    recursion(arr) {
      let obj;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].options) {
          obj = this.recursion(arr[i].options)
          if (obj) {
            return obj
          }
        }
        if (arr[i].enterprise_id && arr[i].enterprise_id == this.enterprise_id) {
          // obj = arr[i]

          return arr[i];
        }
      }

    },
    // 获取数据字典值
    async getDictsData(dict, optionsNmae) {
      let options = [];
      await this.$tools
          .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
            data: {
              dictionary_code: dict,
            },
          })
          .then((res) => {
            if (res.data.code == 0) {
              options = res.data.data.dictionary_detail;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
      this[optionsNmae] = options;
    },
    // 获取职位类型级联下拉
    getPostionTypeOptions() {
      this.$tools
          .asyncPost(this, this.$baseUrl.hierdictlist, {})
          .then((res) => {
            if (res.data.code == 0) {
              this.options1 = res.data.data;
            } else {
              // this.$message({ type: "error", message: res.data.msg });
            }
          })
          .catch((err) => {
            // this.$message({ type: "error", message: err });
          });
    },
    getList() {
      this.loading = true;
      this.postForm.page = this.currentPage
      this.postForm.limit = this.pagesize
      let formaterFileds = {
        ctime_start: this.formatObj.date1.length ? this.formatObj.date1[0] : "",
        ctime_end: this.formatObj.date1.length ? this.formatObj.date1[1] : "",

      }
      this.$tools
          .asyncPost(
              this,
              this.$baseUrl.trainingCourseVideoList, {
                data: Object.assign(this.postForm, formaterFileds)
              }).then((res) => {
        if (res.data.code == 0) {

          this.tableData = res.data.data.data

          console.log(this.tableData);
          this.total = res.data.data.total
        } else {
          this.$message({type: "error", message: res.data.msg});
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    oper(type, row) {
      switch (type) {
        case '1':
          if (this.checkList.length == 0) {
            return this.$message({type: "error", message: "请选择数据"});
          }
          this.$refs.dialogForm1.dialogVisible = true
          this.$refs.dialogForm1.init(this.checkList)
          break;
        case '2':

          this.$MessageBox.confirm('确定要删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCourseVideoDel, {
                      data: {
                        ids: [row.id],
                      }
                    }).then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getList();
              } else {
                this.$message({type: "error", message: res.data.msg});
              }

            }).catch((err) => {
            });
          })
          break;
        case '3'://审核
          this.$refs.dialogForm1.dialogVisible = true
          this.$refs.dialogForm1.init(row)

          break;
        case '4'://查看
          this.$refs.dialogFormPreview.dialogVisible = true
          this.$refs.dialogFormPreview.init(row)
          break;
        default:
          break;
      }
    },
    ok(type) {
      switch (type) {
        case '1':
          this.getList()
          break;
        case '2':
          this.getList()
          break;
        default:
          break;
      }
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    handleSizeChange: function (size) {
      this.pagesize = size; //每页下拉显示数据
      this.getList();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage; //点击第几页
      this.getList();
    },
    search() {
      // console.log(value);
      // this.postForm1.enterprise_id = value
      this.currentPage = 1

      this.getList()

    },
    // 重置
    reset() {

      let obj = {
        "position_type_id": "",//类型
        "enterprise_name": "",//企业名称
        "position_name": "",//职位名称
        "position_bidding_state": "",//竞价状态
        "position_bidding_start": "",//竞价开始时间
        "position_bidding_end": "",//竞价结束时间
        tags_keys: [],//标签
      }
      Object.keys(obj).forEach((key) => {
        this.postForm[key] = obj[key];
      });
      this.formatObj.date1 = []
      this.formatObj.position_type_id = []

      this.currentPage = 1;
      // this.pagesize = 10;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less" src="./index.less"></style>